// extracted by mini-css-extract-plugin
export default {"butonHeader":"CustomHeader_butonHeader__ISC27","center":"CustomHeader_center__gAw0q","tittle":"CustomHeader_tittle__l1sgK"};